<div fxLayout>
  <main fxFlex [ngClass.lt-md]="{ mobile: true, subnav__exists: false }">
    <h2 fxLayout fxLayoutAlign="start center" fxLayoutGap="10px">
      <img class="clickable" [routerLink]="['../']" src="/assets/iconography/arrow-left-rose.svg" />
      <span fxFlex>Email routing</span>
    </h2>

    <sbnb-helptext-wrapper
      class="helptext-wrapper-type-content"
      [area]="'content'"
      [pageId]="'apps-email-routing'"></sbnb-helptext-wrapper>

    <div fxLayout fxLayout.lt-md="column" fxLayoutGap="40px">
      <div fxFlex>
        <h3>Details</h3>
        <p>Here's a list of active email routes that you have already setup:</p>

        <ng-container *ngIf="emails && emails.length > 0; else noKeys">
          <ng-container *ngFor="let email of emails">
            <span class="email__address">
              <strong>{{ displayEmailAddress(email) }}</strong>
              <span>forwards to:</span>
            </span>
            <div class="webhook__container" fxLayout fxLayoutGap="24px" fxLayoutAlign="start center">
              <mat-form-field fxFlex>
                <input
                  matInput
                  placeholder="Email address(es) to route all emails to"
                  [(ngModel)]="email.forward_to"
                  [matTooltip]="'Comma-separate to add multiple email addresses'" />
                <span
                  *ngIf="!email.deleting && email.id"
                  class="webhook__delete text__small clickable"
                  (click)="deleteEmail(email)">
                  Delete
                </span>
                <mat-spinner *ngIf="email.deleting" class="webhook__delete" [diameter]="16"></mat-spinner>
              </mat-form-field>

              <button
                *ngIf="email.id"
                [disabled]="email.updating || email.updateResult"
                type="submit"
                mat-flat-button
                class="button__secondary"
                (click)="updateEmail(email)">
                <span *ngIf="!email.updating && !email.updateResult">Update</span>
                <span *ngIf="email.updateResult">{{ email.updateResult ? 'Updated' : 'Failed' }}</span>
                <mat-spinner class="button__spinner" *ngIf="email.updating" diameter="30"></mat-spinner>
              </button>

              <button
                *ngIf="!email.id"
                [disabled]="email.saving || email.saveResult"
                type="submit"
                mat-flat-button
                class="button__secondary"
                (click)="createEmail(email)">
                <span *ngIf="!email.saving && !email.saveResult">Save</span>
                <span *ngIf="email.saveResult">{{ email.saveResult ? 'Saved' : 'Failed' }}</span>
                <mat-spinner class="button__spinner" *ngIf="email.saving" diameter="30"></mat-spinner>
              </button>
            </div>
          </ng-container>
        </ng-container>

        <ng-template #noKeys>
          <div class="table__no-items strong">You don't seem to have any email routes setup yet...</div>
        </ng-template>

        <button [disabled]="generatingEmail" type="submit" mat-flat-button (click)="generateEmail()">
          <span>Create a new email route</span>
          <mat-spinner *ngIf="generatingEmail" class="button__spinner" [diameter]="30"></mat-spinner>
        </button>
      </div>
    </div>
  </main>
</div>
